import React from "react";
import CompaniesDescriptions from "../../components/companies/CompanyDescription";
import explorer from "../../assets/img/fe/explorer.svg";
import logo from "../../assets/img/fe/logo-vr-voyage.svg";
import landscape from "../../assets/img/fe/landscape.svg";
import landscapeDesktop from "../../assets/img/fe/landscape-desktop.svg";
import MainLayout from "../../layouts/MainLayout";

const ForagerEducation = () => {
  return (
    <MainLayout styleNav={"bg-navy-blue"} showLogo={"hidden"} className="pb-20">
      <CompaniesDescriptions
        logo={require("../../assets/logos/logo-forager-education.png")}
        styleLogo="w-48"
        map={require("../../assets/img/companies/forager-education-map.png")}
        link={{
          name: "visit forager education",
          href: "https://www.foragereducation.com",
        }}
        description={
          <>
            <div className="flex flex-col gap-5 mb-20 2xl:mb-40">
              <h3 className="text-xl text-navy-blue font-medium">
                empowering innovation in the classroom
              </h3>
              <p>
                Forager Education Canada was launched in 2021 after close
                consultations with the BC Museums Association. It works directly
                with heritage organizations to plan, research, and develop
                educational programs and resources that are informative and
                engaging at the same time. By providing teacher-led curriculum
                development services along with audience generation through its
                education portal, The VR Voyage Classroom, Forager Education has
                been honoured to represent Canadian youth entrepreneurship twice
                at the G20 Young Entrepreneurs’ Alliance Summit, first in Milan,
                Italy, and later in Hamburg, Germany.
              </p>
              <p>
                Branching outside of British Columbia, Forager Education is now
                set to become a leader in collaborative curriculum development
                for the heritage sector.
              </p>
            </div>
          </>
        }
      />
      <div className="bg-page-foregaer-education">
        <div className="lg:px-0">
          <div className="container mx-auto text-white grid grid-cols-2 md:pt-20">
            <div className=" justify-end flex flex-col md:flex-col-reverse px-4 lg:px-0 col-span-2 md:col-span-1">
              <img src={explorer} alt="" className="pt-16 lg:w-8/12 mx-auto" />
              <img
                src={logo}
                alt=""
                className="pt-14 md:pt-0 w-9/12 lg:w-72 mx-auto"
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <div className="px-4 lg:px-0 pb-20 xl:pb-10 pt-20 md:pt-0 grid gap-6">
                <h1 className="text-2xl font-medium">
                  bringing the world into{" "}
                  <span className="block lg:inline">the classroom</span>
                </h1>
                <p>
                  The VR Voyage Classroom is an innovative educational portal
                  that allows heritage institutions to publish and promote their
                  educational experiences and resources making them directly
                  available to teachers. The platform utilizes Forager
                  Education’s educators to review and align all content with the
                  provincial and territorial curriculum to ensure it remains a
                  relevant and invaluable resource for teachers when planning
                  lessons and field trips.
                </p>
                <h1>
                  Collaborative in nature, the platform was developed with the
                  intent to provide valuable learning opportunities for
                  classrooms, but also to provide new avenues for institutions
                  to develop and monetize their programming.
                </h1>
              </div>
              <div className="relative">
                <img src={landscape} alt="" className="md:hidden w-full" />
              </div>
            </div>
          </div>
          <img
            src={landscapeDesktop}
            alt=""
            className="hidden md:block w-7/12 ml-auto lg:-mt-40 xl:-mt-48 2xl:-mt-72"
          />
        </div>
        <div className="container mx-auto"></div>
      </div>
    </MainLayout>
  );
};

export default ForagerEducation;
